import stimulusHighlightsActions from '../actions/StimulusHighlightsActions';

export default function responseReducer(state = [], action) {
    switch (action.type) {
    case stimulusHighlightsActions.types.SECTION_HIGHLIGHTS_SET:
        return action.stimulusHighlights;

    default:
        return state;
    }
}
